var _defs, _path, _path2, _path3, _path4, _rect, _rect2, _polygon, _path5, _rect3, _rect4, _polygon2, _path6, _path7, _path8, _path9, _rect5, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228 551.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2b6eae;}.a,.b,.c{opacity:0.2;}.b{fill:#5badff;}.c{fill:#0083e8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hammer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3039.92,1155.24s-13.2-25.63-13.2-83.13c0-103.75,14-225.11,14-225.11h13s14,121.36,14,225.11c0,57.5-13.28,83.83-13.28,83.83Z",
    transform: "translate(-2933 -631)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3053.72,763s14,13.39,14,36.5-14,36.5-14,36.5h-13s-14-13.39-14-36.5,14-36.5,14-36.5h13Z",
    transform: "translate(-2933 -631)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3062,841.5a5.5,5.5,0,0,1-5.5,5.5h-18a5.5,5.5,0,0,1-5.5-5.5h0a5.5,5.5,0,0,1,5.5-5.5h18a5.5,5.5,0,0,1,5.5,5.5h0Z",
    transform: "translate(-2933 -631)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3072,757.5a5.5,5.5,0,0,1-5.5,5.5h-38a5.5,5.5,0,0,1-5.5-5.5h0a5.5,5.5,0,0,1,5.5-5.5h38a5.5,5.5,0,0,1,5.5,5.5h0Z",
    transform: "translate(-2933 -631)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 64,
    y: 16,
    width: 100,
    height: 105
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    y: 16,
    width: 6,
    height: 105
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "64 15.72 64 120.72 54 123.72 54 12.72 64 15.72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2987,714v41.22a34.36,34.36,0,0,0-14-3v-105a34.36,34.36,0,0,0,14-3V685",
    transform: "translate(-2933 -631)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 6,
    width: 34,
    height: 139,
    rx: 17,
    ry: 17
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 222,
    y: 16,
    width: 6,
    height: 105
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "164 15.72 164 120.72 174 123.72 174 12.72 164 15.72"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3107,714v41.22s5-3,14-3v-105c-9,0-14-3-14-3V685",
    transform: "translate(-2933 -631)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3155,648a17,17,0,0,0-17-17h0a17,17,0,0,0-17,17V753a17,17,0,0,0,17,17h0a17,17,0,0,0,17-17V648Z",
    transform: "translate(-2933 -631)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3039.81,1155.24s-13.14-25.63-13.14-83.13c0-103.75,14.06-225.11,14.06-225.11H3047v308.62Z",
    transform: "translate(-2933 -631)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3047,836h-6.28s-14-13.39-14-36.5,14-36.5,14-36.5H3047v73Z",
    transform: "translate(-2933 -631)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 64,
    y: 16,
    width: 50,
    height: 105
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 113.53,
    cy: 537.22,
    r: 14.56
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.eb4ac3e55cb8d4f598045ed09f3b4a75.svg";
export { ForwardRef as ReactComponent };